import React, { Suspense } from 'react';
import { ArrowRight } from 'lucide-react';
import IndustrialBackground from './IndustrialBackground';

const Spline = React.lazy(() => import('@splinetool/react-spline'));

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#000000',
      paddingTop: '80px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Industrial Background with Robot Animations */}
      <IndustrialBackground />
      
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '60px 7.6923%',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '60px',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Left Content */}
        <div style={{ zIndex: 2 }}>
          <h1 style={{
            fontSize: '66px',
            fontWeight: 600,
            lineHeight: 1.1,
            letterSpacing: '-0.62px',
            color: '#FFFFFF',
            marginBottom: '24px'
          }}>
            Transformación Digital para la <span style={{ color: '#00FFD1' }}>Industria 4.0</span>
          </h1>
          
          <p style={{
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: 1.5,
            color: 'rgba(255, 255, 255, 0.85)',
            marginBottom: '40px'
          }}>
            Impulsamos tu empresa hacia el futuro con tecnologías emergentes: Big Data, IA, Blockchain, IoT y más.
          </p>

          <button onClick={scrollToContact} className="btn-primary">
            Solicitar Consulta
            <ArrowRight size={20} />
          </button>
        </div>

        {/* Right Content - Spline Animation */}
        <div style={{
          width: '100%',
          height: '700px',
          overflow: 'visible',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2
        }}>
          <Suspense fallback={
            <div style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#00FFD1'
            }}>
              Cargando animación 3D...
            </div>
          }>
            <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
          </Suspense>
        </div>
      </div>
    </section>
  );
};

export default Hero;